module.exports = __webpack_public_path__ + "img/portrait_1920.41b674f5.webp";